
export function zoomProjection(delta: number): void {
    // @ts-ignore
    const iframe = window.containerRef?.current?.contentWindow;
    iframe.ZoomProjection(delta);
} 